import AttributesReadOnly from './AttributesReadOnly'

export default AttributesReadOnly
